/*
 * @fileOverView Password Show component definition
 */

import Vue from 'vue';

Vue.component('passwordshow-vue', {
  methods: {
    showPassword: function () {
      this.$emit('password:mousedown', this.$el);
    },

    hidePassword: function () {
      this.$emit('password:mouseup', this.$el);
    }
  }
})
